import React from "react";
// import styled from "styled-components";
// import { Grid } from "@material-ui/core";
// import stylinggs from "./styling.scss";

// This contains all the components from the frontpage :)
//
// Here **
import useStyles from "./styles";
// BANNER
import BannerTop from "./BannerTop";
import BannerBottom from "./BannerBottom";
import Product from "./Product/Product";
import Footer from "../Footer";

//

//
//
//

/*
 */

const Products = ({ products, onAddToCart }) => {
  //wrapper of the container
  //containing the imgs from the welcome page
  // Here **
  const classes = useStyles();
  //
  return (
    <>
      <BannerTop />
      <section className={classes.wrapperSoonProductsGrid}>
        <h1>NEW IN</h1>
        {/*  */}
        <div className={classes.GridContainerProducts}>
          {products.map((product) => (
            <div key={product.id}>
              <Product product={product} onAddToCart={onAddToCart} />
            </div>
          ))}
        </div>
      </section>
      <BannerBottom />
      {/*  */}
      <section className={classes.wrapperSoonProductsGrid}>
        <h1>LAST CHANCE</h1>

        {/*  */}
        <div className={classes.GridContainerProducts}>
          {products.map((product) => (
            <div key={product.id}>
              <Product product={product} onAddToCart={onAddToCart} />
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </>
  );
};

// const dataStories = [
//   {
//     id: "0",
//     imgStories: "",
//     alt: "img",
//   },
//   {
//     id: "1",
//     imgStories: "",
//     alt: "img",
//   },
//   {
//     id: "2",
//     imgStories: "",
//     alt: "img",
//   },
//   {
//     id: "3",
//     imgStories: "",
//     alt: "img",
//   },
// ];

export default Products;
